import { useQuery } from '@tanstack/react-query'
import { getIndeedFlexAuthStatus } from 'api/admin/indeedFlex/getIndeedFlexAuthStatus'
import { indeedFlexKeys } from './keys'

export function useIndeedFlexAuthStatusQuery() {
  return useQuery({
    queryKey: indeedFlexKeys.authStatus(),
    queryFn: getIndeedFlexAuthStatus,
  })
}
